document.addEventListener("turbo:load", function () {
  const imageModal = document.getElementById('imageModal')
  if (imageModal) {
    imageModal.addEventListener('show.bs.modal', event => {
      const opener = event.relatedTarget;
      const src = opener.getAttribute('data-src');

      const modalImgElm = imageModal.querySelector("img");
      const sourceImg = opener.matches("img") ? opener : opener.querySelector("img");

      modalImgElm.setAttribute("src", src);
      modalImgElm.setAttribute("alt", (sourceImg && sourceImg.getAttribute("alt")) || "");
    });

    imageModal.addEventListener("hide.bs.modal", event => {
      const modalImgElm = imageModal.querySelector("img");
      modalImgElm.setAttribute("src", "");
      modalImgElm.setAttribute("alt", "");
    });
  }
});